import React from "react";
import { useSubscriptionStatistics } from "@containers/PayPerLead/hooks/useSubscriptionStatistics";
import { ViewSubscriptionsLink } from "@containers/PayPerLead/components/ViewSubscriptionsLink";
import { Button } from "@shared/components";
import { NameOfChildRoutes } from "@shared/constants";
import { useNavigate } from "react-router-dom";
import { Progress } from "rsuite";
import { PayPerLeadSubscription, StateIdType } from "@containers/PayPerLead/interface";

import "./index.scss";

interface MonthlyLeadsProps {
  subscriptions: PayPerLeadSubscription[];
}

const MonthlyLeads = ({ subscriptions }: MonthlyLeadsProps) => {
  const hasAllStatesSubscription = subscriptions.some(
    (s) => s.is_active && s.items.some((i) => i.state_id === StateIdType.Nationwide),
  );
  const { monthlyLeadsReceived, monthlyLeadsLimit } = useSubscriptionStatistics();
  const navigate = useNavigate();
  const purchase = () => {
    navigate(
      `${NameOfChildRoutes.PAY_PER_LEAD.ROOT}/${NameOfChildRoutes.PAY_PER_LEAD.SUBSCRIPTIONS}/${NameOfChildRoutes.PAY_PER_LEAD.ADD}`,
    );
  };

  const receivedPercentage = (monthlyLeadsReceived / monthlyLeadsLimit) * 100;

  return (
    <div className="card-item">
      <div className="content">
        <div className="header">
          <div className="title">MONTHLY LEADS</div>
          <div>
            <ViewSubscriptionsLink>View Subscriptions</ViewSubscriptionsLink>
          </div>
        </div>
        <div className="summary">
          <div className="details">
            <div className="total">
              {monthlyLeadsReceived}/{monthlyLeadsLimit}
            </div>
            <Progress.Line showInfo={false} className="progress-bar" percent={+receivedPercentage || 0} />
          </div>
          {!hasAllStatesSubscription && (
            <Button onClick={purchase} buttonStyle="blue-bordered" className="blue-bordered">
              Add Leads
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MonthlyLeads;
